// extracted by mini-css-extract-plugin
export default {"basketContainer":"basketContainer__29Wtd"};
    if(module.hot) {
      // 1788784374236
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  